export default {
    orders: {
        actionUndo: {
            message: "Se hai fatto clic per errore, fai clic sul collegamento sottostante per ripristinare.",
            undo: "Fare clic per annullare"
        }
    }
}